module.exports = __webpack_public_path__ + "images/fiata4e08a5a2d97dc13281e1e345337779c.png";